import React from 'react';

export function ContactMe() {
  return (
    <div className="contacts">
      <section>Связаться со мной можно через:</section>
      <section>
        <a href="https://www.linkedin.com/in/nicolasolenev/">LinkedIn</a>
      </section>
      <section>
        <a href="https://t.me/StLi2"> Telegram</a>
      </section>
      <section>
        <a href="viber://chat?number=+375255138085">Viber</a>
      </section>
    </div>
  );
}
